import React, { useState } from 'react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { Box, toast } from '@node-space/ui-components'
import { RewardsEmbeddedDisburseDialog } from './RewardsEmbeddedDisburseDialog'
import { RewardsEmbeddedEarningsChart } from './RewardsEmbeddedEarningsChart'
import { RewardsEmbeddedGiveBack } from './RewardsEmbeddedGiveBack'
import { RewardsEmbeddedSummary } from './RewardsEmbeddedSummary'

export const RewardsEmbeddedCustomer = () => {
  const { t } = useTranslation()
  const [openDisburseDialog, setOpenDisburseDialog] = useState(false)
  const [hasBeenDisbursed, setHasBeenDisbursed] = useState(false)

  const handleDisburse = () => {
    toast({
      header: t('rewards.embeddedCustomers.disburseDialog.successMessage'),
      variant: 'success',
    })
    setHasBeenDisbursed(true)
    setOpenDisburseDialog(false)
  }

  const onOpenDisburseDialog = () => {
    setOpenDisburseDialog(true)
  }

  return (
    <Box flexCol gap={16}>
      <Box
        gap={16}
        flexCol
        className={clsx({
          'xl:grid xl:grid-cols-2': !hasBeenDisbursed,
        })}
      >
        <RewardsEmbeddedSummary
          currency={'USDC'}
          baseCurrency={'USD'}
          totalBalance={430000}
          totalEarnings={3200}
          hasBeenDisbursed={hasBeenDisbursed}
        />

        <RewardsEmbeddedGiveBack
          onDisburse={onOpenDisburseDialog}
          hasBeenDisbursed={hasBeenDisbursed}
        />
      </Box>

      <RewardsEmbeddedEarningsChart />

      <RewardsEmbeddedDisburseDialog
        onDisburse={handleDisburse}
        open={openDisburseDialog}
        onClose={() => setOpenDisburseDialog(false)}
      />
    </Box>
  )
}
